/**
 * Version synchrone pour imports server-side (SSR)
 * @param {string} key - Clé à récupérer
 * @param {string} clientName - Nom du client (optionnel, déduit de la config par défaut)
 * @returns {*} Valeur de l'extension
 */
const getExtensionValueSync = (key) => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const getConfig = require('next/config').default;
    const { publicRuntimeConfig } = getConfig();
    const client = publicRuntimeConfig?.clientName || 'default';

    // eslint-disable-next-line import/no-dynamic-require, @typescript-eslint/no-var-requires
    const extension = require(`../extensions/${client}/extension.plugin.js`).default;

    return extension[key] || null;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(`Extension non trouvée ou key manquante: ${key}`, error);

    return null;
  }
};

module.exports = {
  getExtensionValueSync,
};
